import { State } from '../state';
import { createSelector, MemoizedSelector } from '@ngrx/store';
import { selectBpmnProcessState } from './bpmn-process-state.selector';

const getProcessInstanceId = (state: State): any => state.processInstanceId;

export const selectProcessInstanceId: MemoizedSelector<
  object,
  string
  > = createSelector(selectBpmnProcessState, getProcessInstanceId);
